import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import {
  IconAlertTriangle,
  IconLoader2,
  IconArrowLeft,
  IconShieldCheck
} from '@tabler/icons-react';

const RestoreAccountPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Токен не указан');
      return;
    }

    fetch('/api/auth/restore-account', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token })
    })
      .then((r) => r.json().then((d) => ({ ok: r.ok, data: d })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.error || 'Ошибка восстановления');
        setStatus('success');
        setMessage(data.message || 'Аккаунт восстановлен');
      })
      .catch((e) => {
        setStatus('error');
        setMessage(e.message);
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-white dark:bg-dark-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {status === 'loading' && (
          <>
            <IconLoader2 className="w-12 h-12 text-primary-500 animate-spin mx-auto mb-4" />
            <p className="text-gray-600 dark:text-dark-400">Восстанавливаем аккаунт...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 rounded-full bg-green-500/10 flex items-center justify-center mx-auto mb-4">
              <IconShieldCheck className="w-8 h-8 text-green-500" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Аккаунт восстановлен!</h1>
            <p className="text-gray-600 dark:text-dark-400 mb-6">{message}</p>
            <Link
              to="/login"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 rounded-lg font-semibold text-white transition"
            >
              Войти
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center mx-auto mb-4">
              <IconAlertTriangle className="w-8 h-8 text-red-500" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Ошибка</h1>
            <p className="text-gray-600 dark:text-dark-400 mb-6">{message}</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 rounded-lg font-semibold text-white transition"
            >
              <IconArrowLeft className="w-4 h-4" />
              На главную
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default RestoreAccountPage;
